import store from "@/store";
import moment from "moment";
import { app } from "@/main.js";

export default (to, from, next) => {

	let serverHost = app.config.globalProperties.$config.getServerHost().toString();

	let currentTime = new Date().toISOString();
	let tokenExpiry = store.state.auth.tokenExpiry;

	if (serverHost.includes("localhost") || serverHost.includes("127.0.0.1")) {
		currentTime = new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60 * 1000).toISOString();
		tokenExpiry = new Date(store.state.auth.tokenExpiry).toISOString();
	}

	// check if token is expired
	if (moment(currentTime).isSameOrAfter(tokenExpiry)) {
		store.commit("auth/setIsTokenExpired");
	}

	// check if user has been idle for too long
	if (store.state.auth.isAuthenticated && store.state.auth.lastActive) {
		const timeoutMinutes = process.env.VUE_APP_SESSION_TIMEOUT_MINUTES ? parseInt(process.env.VUE_APP_SESSION_TIMEOUT_MINUTES) : 45;
		const idleTimeoutMs = timeoutMinutes * 60 * 1000;
		const now = new Date().getTime();
		if (now - store.state.auth.lastActive > idleTimeoutMs) {
			store.commit("auth/setIsTokenExpired");
		} else {
			// User is active! Check if the token is close to expiring (less than 30 minutes remaining of its 2 hours)
			const tokenExpiryVal = store.state.auth.tokenExpiry;
			if (tokenExpiryVal) {
				const expiryMs = new Date(tokenExpiryVal).getTime();
				const timeToExpiryMs = expiryMs - now;
				// If token is expiring in less than 30 minutes (and not already completely expired)
				if (timeToExpiryMs > 0 && timeToExpiryMs < 30 * 60 * 1000) {
					store.dispatch("auth/refreshToken");
				}
			}
		}
	}

	if (to.meta.requiresAuth && (!store.state.auth.isAuthenticated || store.state.auth.isTokenExpired)) {

		if (to.path != "/" || to.path != "" || to.path != null) {
			store.commit("auth/setRedirectLink", to.path);
		}

		store.dispatch("auth/logout");
		return next();
	}

	return next();
}
